<template>
  <div class="flex flex-col md:flex-row md:items-center md:gap-6">
    <router-link
      to="/documentation"
      class="text-sm font-medium text-gray-500 hover:text-primary"
      :class="{ 'text-primary font-semibold': isDocumentationActive }"
      @click="handleNavClick"
    >
      {{ $t('nav.documentation') }}
    </router-link>
    <router-link
      to="/contacts"
      class="text-sm font-medium text-gray-500 hover:text-primary"
      :class="{ 'text-primary font-semibold': isContactsActive }"
      @click="handleNavClick"
    >
      {{ $t('nav.contacts') }}
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps<{
  isLoggedIn: boolean
  currentRoute: string
}>()

const route = useRoute()

const isDocumentationActive = computed(() => {
  return props.currentRoute === '/documentation'
})

const isContactsActive = computed(() => {
  return props.currentRoute === '/contacts'
})

// Handler for preventing redundant navigation
const handleNavClick = (event: Event) => {
  const target = event.target as HTMLAnchorElement
  const href = target.getAttribute('href')

  // If trying to navigate to current page, cancel navigation
  if (href && route.path === href) {
    event.preventDefault()
    return false
  }
}
</script>
